import React from 'react';
import { FaShieldAlt, FaUsers, FaTruck, FaCheckCircle, FaHandshake, FaStar, FaHeart, FaPhone, FaBox, FaDollarSign } from 'react-icons/fa';
import './About.css';

const About = () => {
    return (
        <div className="about-page">
            <div className="page-header">
                <div className="container">
                    <div className="header-line"></div>
                    <h1>About Us</h1>
                    <p>We are a team of dedicated professionals committed to delivering excellence and innovation. Our passion drives us to create meaningful solutions that make a difference.</p>
                </div>
            </div>

            {/* About Team Section */}
            <section className="about-team-section">
                <div className="container">
                    <div className="about-team-content">
                        <div className="about-team-text">
                            <span className="badge">ABOUT US</span>
                            <h2>Bk <span>Packers & Movers</span> Team</h2>
                            <p>Bk Packers & Movers is a premier relocation company with a legacy of trust and excellence. Founded in 2023, we have grown to become one of India's most reliable names in the packing and moving industry.</p>
                            <div className="about-features">
                                <div className="about-feature-item">
                                    <FaCheckCircle className="check-icon" />
                                    <span>Safety</span>
                                </div>
                                <div className="about-feature-item">
                                    <FaCheckCircle className="check-icon" />
                                    <span>Pan India Network</span>
                                </div>
                                <div className="about-feature-item">
                                    <FaCheckCircle className="check-icon" />
                                    <span>Trained Staff</span>
                                </div>
                                <div className="about-feature-item">
                                    <FaCheckCircle className="check-icon" />
                                    <span>GPS Tracking</span>
                                </div>
                            </div>
                        </div>
                        <div className="about-team-image">
                            <img src="/Images/Bk%20Packers%20%26%20Movers%20Team_2.png" alt="BK Team" loading="lazy" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Journey Section */}
            <section className="journey-section">
                <div className="container">
                    <span className="badge-yellow">Our Journey</span>
                    <h2>Bk <span>Packers & Movers</span></h2>
                    <div className="journey-cards">
                        <div className="journey-card journey-dark">
                            <div className="journey-icon">
                                <FaTruck />
                            </div>
                            <h3>2023 - The Beginning</h3>
                            <p>Started with just 2 trucks and a vision to transform the relocation industry. Our founder believed in honest service and customer-first approach.</p>
                        </div>
                        <div className="journey-card journey-red">
                            <div className="journey-icon">
                                <FaBox />
                            </div>
                            <h3>2024 - Rapid Growth</h3>
                            <p>Extended operations to 100+ cities with a fleet of 50 vehicles. Introduced advanced packing materials and professional training programs for our team.</p>
                        </div>
                        <div className="journey-card journey-dark">
                            <div className="journey-icon">
                                <FaStar />
                            </div>
                            <h3>2026 - Industry Leader</h3>
                            <p>Now serving 500+ clients with 34 vehicles, GPS tracking, and a dedicated team of 2024 professionals. Recognized as a top packers and movers brand in India.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Achievements */}
            <section className="achievements-section">
                <div className="container">
                    <h2>Our Achievements</h2>
                    <div className="achievements-grid">
                        <div className="achievement-card">
                            <h3>3+</h3>
                            <p>YEARS OF EXPERIENCE</p>
                        </div>
                        <div className="achievement-card">
                            <h3>500+</h3>
                            <p>CLIENTS SERVED</p>
                        </div>
                        <div className="achievement-card">
                            <h3>700+</h3>
                            <p>SUCCESSFUL MOVES</p>
                        </div>
                        <div className="achievement-card">
                            <h3>100+</h3>
                            <p>CLIENT SATISFACTION</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className="why-choose-section">
                <div className="container">
                    <span className="badge-red">Our Advantages</span>
                    <h2>Why Choose Bk Packers & Movers?</h2>
                    <p className="subtitle">We don't just move your belongings; we move your trust with utmost care and dedication.</p>
                    <div className="advantages-grid">
                        <div className="advantage-card">
                            <div className="advantage-icon">
                                <FaShieldAlt />
                            </div>
                            <h3>100% Safe Packing</h3>
                            <p>Premium quality 5-layer packing with bubble wrap, thermocol, and corrugated sheets for complete protection.</p>
                        </div>
                        <div className="advantage-card">
                            <div className="advantage-icon">
                                <FaTruck />
                            </div>
                            <h3>Express Delivery</h3>
                            <p>On-time pickup and delivery guaranteed. Track your shipment in real-time with our GPS-enabled fleet.</p>
                        </div>
                        <div className="advantage-card">
                            <div className="advantage-icon">
                                <FaDollarSign />
                            </div>
                            <h3>Best Price Guarantee</h3>
                            <p>Transparent pricing with no hidden costs. Get the most competitive rates in the industry.</p>
                        </div>
                        <div className="advantage-card">
                            <div className="advantage-icon">
                                <FaShieldAlt />
                            </div>
                            <h3>Insurance Coverage</h3>
                            <p>Comprehensive transit insurance to protect your valuables against any unforeseen damages.</p>
                        </div>
                        <div className="advantage-card">
                            <div className="advantage-icon">
                                <FaPhone />
                            </div>
                            <h3>24/7 Customer Support</h3>
                            <p>Dedicated support team available round the clock to assist you at every step of your move.</p>
                        </div>
                        <div className="advantage-card">
                            <div className="advantage-icon">
                                <FaUsers />
                            </div>
                            <h3>Trained Professionals</h3>
                            <p>Experienced and background-verified staff trained in handling all types of goods with care.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Work Process */}
            <section className="work-process-about">
                <div className="container">
                    <h2>Our Work Shifting Process.</h2>
                    <div className="process-steps-about">
                        <div className="step-about">
                            <div className="step-icon-about"><FaPhone /></div>
                            <h3>Request Quote</h3>
                            <p>Get instant estimates, compare services, analyze requirements, understand pricing, plan your move.</p>
                        </div>
                        <div className="arrow-about">→</div>
                        <div className="step-about">
                            <div className="step-icon-about"><FaBox /></div>
                            <h3>Schedule</h3>
                            <p>Book your slot, choose timing, confirm dates, pre-move survey, flexible scheduling options.</p>
                        </div>
                        <div className="arrow-about">→</div>
                        <div className="step-about">
                            <div className="step-icon-about"><FaTruck /></div>
                            <h3>Pack & Load</h3>
                            <p>Professional packing, quality materials, careful handling, secure loading, inventory management.</p>
                        </div>
                        <div className="arrow-about">→</div>
                        <div className="step-about">
                            <div className="step-icon-about"><FaTruck /></div>
                            <h3>Deliver</h3>
                            <p>Real-time tracking, safe transit, timely delivery, unpacking assistance, complete satisfaction.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Core Values */}
            <section className="core-values-section">
                <div className="container">
                    <span className="badge-dark">What We Stand For</span>
                    <h2>Our Core Values</h2>
                    <div className="core-values-grid">
                        <div className="core-value-card">
                            <div className="core-value-icon">
                                <FaHandshake />
                            </div>
                            <h3>Integrity</h3>
                            <p>We maintain complete honesty and transparency in all our dealings.</p>
                        </div>
                        <div className="core-value-card">
                            <div className="core-value-icon">
                                <FaStar />
                            </div>
                            <h3>Excellence</h3>
                            <p>We strive for excellence in every service we provide.</p>
                        </div>
                        <div className="core-value-card">
                            <div className="core-value-icon">
                                <FaCheckCircle />
                            </div>
                            <h3>Reliability</h3>
                            <p>Customers can always count on us to deliver our promises.</p>
                        </div>
                        <div className="core-value-card">
                            <div className="core-value-icon">
                                <FaHeart />
                            </div>
                            <h3>Care</h3>
                            <p>We treat your belongings as if they were our own.</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;


